import { useEffect, useState, useTransition } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { SearchResultsHierarchy } from "./SearchResultsHierarchy";
import { SearchResultsTlf } from "./SearchResultsTlf";

/**
 * Search page component. Renders a search input and shows hierarchy and TLF
 * search results once a three-character query is entered.
 */
export const Search = (): React.ReactElement => {
  const [_isPending, startTransition] = useTransition();
  const [subText, setSubText] = useState<string>("");
  const [currentValue, setCurrentValue] = useState<string>("");
  const [searchText, setSearchText] = useState<string | null>(null);

  // Update subtext
  useEffect(() => {
    startTransition(() => {
      setSubText(
        currentValue.trim().length < 3
          ? "Enter 3 or more characters to search"
          : currentValue !== searchText
            ? "..."
            : "",
      );
    });
  }, [currentValue, searchText]);

  // Search results + debounce
  useEffect(() => {
    const update = setTimeout(() => {
      if (currentValue !== searchText && currentValue.trim().length > 2) {
        setSearchText(currentValue);
      }
    }, 1000);
    return () => clearTimeout(update);
  }, [currentValue, searchText]);

  return (
    <>
      <Form.Group
        controlId="search-entry"
        as={Row}
        className="d-flex under-nav-sticky"
      >
        <Form.Label
          column
          sm={2}
          style={{ minHeight: "70px" }}
        >
          Search
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            className="m-1"
            type="text"
            value={currentValue}
            onChange={(e) => setCurrentValue(e.currentTarget.value)}
            spellCheck={true}
          />
          <Form.Text>{subText}</Form.Text>
        </Col>
      </Form.Group>
      {searchText !== null && (
        <>
          <Row>
            <Col>
              <SearchResultsHierarchy searchText={searchText} />
            </Col>
          </Row>
          <Row>
            <Col>
              <SearchResultsTlf searchText={searchText} />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

Search.displayName = "Search";
